export default "__VITE_ASSET__YdxdBEII__"